// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as IconMadeWithMaker$Showside from "../icons/IconMadeWithMaker.bs.js";
import * as IntersectionObserver$Showside from "../utils/IntersectionObserver.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function MadeWithMaker(Props) {
  var link = "https://mkr.bio/?utm_medium=referral&utm_source=mkr.bio&utm_campaign=madeinmakerb";
  var ref = React.useRef(null);
  ConfigurationProvider$Showside.use(undefined).config;
  var match = React.useState(function () {
    return true;
  });
  var setShowFixedWatermark = match[1];
  var intersection = IntersectionObserver$Showside.use(ref, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var trackEvent = match$1.trackEvent;
  var onClick = function (param) {
    Curry.app(trackEvent, ["mkrbio:made_with_maker", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  React.useEffect(function () {
    Curry._1(setShowFixedWatermark, function (param) {
      return !intersection.isIntersecting;
    });
  }, [intersection.isIntersecting]);
  var watermarkContent = React.createElement(React.Fragment, undefined, React.createElement(IconMadeWithMaker$Showside.make, {
    className: CSS$Showside.prefix("w-36")
  }));
  var commonCn = Cn.make(["flex items-center justify-center", "space-x-1.5", "bg-white text-gray-500", "hover:text-black", "text-base"]);
  var className = CSS$Showside.prefix(Cn.make([commonCn, "h-12 w-full", "-mt-12"]));
  var relativeWatermark = React.createElement(Link$Showside.make, {
    children: React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(ref),
      className: className
    }, watermarkContent),
    href: link,
    unstyled: true,
    className: CSS$Showside.prefix("no-underline relative"),
    dataTestId: "made-with-maker-watermark",
    onClick: onClick
  });
  var className$1 = CSS$Showside.prefix(Cn.make([commonCn, "py-2 px-3", "fixed right-0 bottom-0", "rounded-l-sm", "transform", match[0] ? "translate-y-0" : "translate-y-full", "transition-transform duration-300"]));
  var fixedWatermark = React.createElement(Link$Showside.make, {
    children: React.createElement("div", {
      className: className$1,
      style: {
        zIndex: "2147483647"
      }
    }, watermarkContent),
    href: link,
    unstyled: true,
    dataTestId: "made-with-maker-watermark",
    onClick: onClick
  });
  return React.createElement(React.Fragment, undefined, relativeWatermark, React.createElement(BaseWithTheme$Showside.make, {
    initiator: "maker-watermark",
    portal: true,
    children: fixedWatermark
  }));
}
MadeWithMaker.displayName = "MadeWithMaker";
var make = MadeWithMaker;
var $$default = MadeWithMaker;
export { make, $$default, $$default as default };
/* react Not a pure module */